module.exports = __webpack_public_path__ + "img/ic_20_answer_white.0c0a01ed.svg";